import { normalizeInvoices } from '@/lib/adapters/advertiser.adapter'
import { useApi } from '@/lib/helpers/api.helpers'
import { request } from '@/lib/services'

export const useGetInvoices = (id: number) =>
  useApi(async () => {
    const { data } = await request.get(`/stores/${id}/invoices`)
    return normalizeInvoices(data)
  })
